/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Button, Dialog, Typography2 } from '@coursera/cds-core';

import TrackedButton from 'bundles/page/components/TrackedButton';
import { getPortfolioProjectHideDialogTranslations } from 'bundles/portfolio-projects/constants';
import EVENTS from 'bundles/portfolio-projects/events';

export type Props = {
  open: boolean;
  loading?: boolean;
  onClose: () => void;
  onHide: () => void;
};

const styles = {
  buttonGroup: css`
    display: flex;
    gap: var(--cds-spacing-200);
  `,
};

const PortfolioProjectHideDialog = ({ open, onClose, onHide, loading = false }: Props) => {
  const { Actions, Content, HeadingGroup } = Dialog;
  const {
    PORTFOLIO_PROJECT_HIDE_DIALOG_TITLE,
    PORTFOLIO_PROJECT_HIDE_DIALOG_DESCRIPTION,
    PORTFOLIO_PROJECT_HIDE_DIALOG_HIDE_LABEL,
    PORTFOLIO_PROJECT_HIDE_DIALOG_CANCEL_LABEL,
  } = getPortfolioProjectHideDialogTranslations();

  return (
    <Dialog open={open} onClose={onClose}>
      <HeadingGroup title={PORTFOLIO_PROJECT_HIDE_DIALOG_TITLE}>{PORTFOLIO_PROJECT_HIDE_DIALOG_TITLE}</HeadingGroup>

      <Content>
        <Typography2 component="p" color="supportText">
          {PORTFOLIO_PROJECT_HIDE_DIALOG_DESCRIPTION}
        </Typography2>
      </Content>

      <Actions css={styles.buttonGroup}>
        <Button
          variant="primary"
          size="medium"
          loading={loading}
          onClick={onHide}
          component={TrackedButton}
          withVisibilityTracking
          requireFullyVisible
          trackingName={EVENTS.portfolioBuilderHideConfirmation}
        >
          {PORTFOLIO_PROJECT_HIDE_DIALOG_HIDE_LABEL}
        </Button>
        <Button variant="secondary" size="medium" disabled={loading} onClick={onClose}>
          {PORTFOLIO_PROJECT_HIDE_DIALOG_CANCEL_LABEL}
        </Button>
      </Actions>
    </Dialog>
  );
};

export default PortfolioProjectHideDialog;
